import { fromFetch } from 'rxjs/fetch';
import { requiredHeaders } from '../../models/required-headers';
import { selectData } from '../../utils/select-data';
import { authwsEnvironment } from './authws-environment';
import { accountListSchema } from './schemas/account-list.schema';

export function postAccountList(email: string, pass: string) {
  return fromFetch(
    new Request(authwsEnvironment.accountListUrl, {
      method: 'POST',
      headers: {
        ...requiredHeaders,
      },
      body: JSON.stringify({
        email,
        pass,
      }),
    })
  ).pipe(selectData(accountListSchema));
}
